export const FORGOT_PASSWORD_COMPANY = "FORGOT_PASSWORD_COMPANY";
export const FORGOT_PASSWORD_COMPANY_SUCCESS = "FORGOT_PASSWORD_COMPANY_SUCCESS";
export const FORGOT_PASSWORD_COMPANY_ERROR = "FORGOT_PASSWORD_COMPANY_ERROR";
export const FORGOT_PASSWORD_SAVE_INFO = "FORGOT_PASSWORD_SAVE_INFO";

export const CHANGE_PASSWORD_COMPANY = "CHANGE_PASSWORD_COMPANY";
export const CHANGE_PASSWORD_COMPANY_SUCCESS = "CHANGE_PASSWORD_COMPANY_SUCCESS";
export const CHANGE_PASSWORD_COMPANY_ERROR = "CHANGE_PASSWORD_COMPANY_ERROR";
